import {
  call,
  takeLatest
} from "redux-saga/effects";
import {
  downloadXLSFile
} from "utils/api";
import {
  defaultReturn,
  makePayload,
  generateDefaultActions
} from "store/utils/helpers";

export const EXPORT_COMPANY_GUARANTORS = generateDefaultActions("EXPORT_COMPANY_GUARANTORS");
export const exportCompanyGuarantors = payload => makePayload(EXPORT_COMPANY_GUARANTORS.value, payload);
function* exportCompanyGuarantorsSaga(payload) {
  const url = `loans/${payload.id}/exportCompanyGuarantors`;
  yield call(downloadXLSFile, url, "POST", payload, "");
}

const initialState = {
  companyGuarantors: {

  }
};

export default function companyGuarantorsReducer(state = initialState, action) {
  const {
    type,
    payload,
    subKey
  } = action;
  switch (type) {
    case EXPORT_COMPANY_GUARANTORS.success:
      return defaultReturn(state, payload.data, "companyGuarantors");
    default:
      return state;
  }
}

export function* companyGuarantorsSaga() {
  yield takeLatest(EXPORT_COMPANY_GUARANTORS.value, exportCompanyGuarantorsSaga);
}
